module.exports = __webpack_public_path__ + "img/course2.a1fc0ee4.png";